<template>
  <div class="award-export">
    <button class="btn" @click="isModalShow = true">
      <v-icon class="mr-2">get_app</v-icon>
      <span>匯出報表</span>
    </button>
    <div class="award-export__modal-wrap" v-if="isModalShow">
      <div class="award-export__modal">
        <!-- head -->
        <div class="form-item py-5">
          <h3>匯出報表</h3>
        </div>
        <!-- body -->
        <div>
          <!-- 篩選Award Type -->
          <div class="form-item py-5 d-flex">
            <div class="w-126px mr-5">
              <h4>篩選Award Type</h4>
            </div>
            <div class="flex-grow-1 flex-basis-0 my-n2">
              <SimpleSelectWithSearchInput
                buttonPlaceholder="請選擇Award Type"
                buttonWidth="100%"
                modalBodyHeight="208px"
                modalWidth="100%"
                :options="awardTypeOptions"
                :selectedValue.sync="filter.type"
              ></SimpleSelectWithSearchInput>
            </div>
          </div>
          <div class="form-item py-5">
            <!-- 篩選開始年月 -->
            <div class="py-2 mb-10px d-flex">
              <div class="w-126px mr-5">
                <h4>篩選開始年月</h4>
              </div>
              <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
                <SimpleSelectWithSearchInput
                  class="mr-10px"
                  buttonPlaceholder="請選擇年份"
                  buttonWidth="262px"
                  modalBodyHeight="208px"
                  modalWidth="262px"
                  :options="yearOptions"
                  :selectedValue.sync="filter.time.yearStartAt"
                ></SimpleSelectWithSearchInput>
                <SimpleSelectWithSearchInput
                  buttonPlaceholder="請選擇月份"
                  buttonWidth="262px"
                  modalBodyHeight="208px"
                  modalWidth="262px"
                  :options="monthOptions"
                  :selectedValue.sync="filter.time.monthStartAt"
                ></SimpleSelectWithSearchInput>
              </div>
            </div>
            <!-- 篩選結束年月 -->
            <div class="py-2 d-flex">
              <div class="w-126px mr-5">
                <h4>篩選結束年月</h4>
              </div>
              <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
                <SimpleSelectWithSearchInput
                  class="mr-10px"
                  buttonPlaceholder="請選擇年份"
                  buttonWidth="262px"
                  modalBodyHeight="208px"
                  modalWidth="262px"
                  :options="yearOptions"
                  :selectedValue.sync="filter.time.yearEndAt"
                ></SimpleSelectWithSearchInput>
                <SimpleSelectWithSearchInput
                  buttonPlaceholder="請選擇月份"
                  buttonWidth="262px"
                  modalBodyHeight="208px"
                  modalWidth="262px"
                  :options="monthOptions"
                  :selectedValue.sync="filter.time.monthEndAt"
                ></SimpleSelectWithSearchInput>
              </div>
            </div>
          </div>
        </div>
        <!-- foot -->
        <div class="pa-5 text-right">
          <button class="btn w-100px mr-10px" @click="cancelHandler">
            取消
          </button>
          <button class="btn btn-primary w-100px" @click="exportHandler">
            匯出
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import Str from '@/services/str';

export default {
  components: {
    SimpleSelectWithSearchInput,
  },
  data: () => ({
    isModalShow: false,
    filter: {
      type: '',
      time: {
        yearStartAt: '',
        monthStartAt: '',
        yearEndAt: '',
        monthEndAt: '',
      },
    },
  }),
  computed: {
    ...mapState('award', ['awardTypeOptions']),
    ...mapState(['token']),
    yearOptions() {
      const startYear = 1991;
      const range = new Date().getFullYear() - startYear + 1;
      return [...Array(range).keys()].map((i) => ({
        value: (i + startYear).toString(),
        text: (i + startYear).toString(),
      }));
    },
    monthOptions() {
      return [...Array(12).keys()].map((i) => ({
        value: (i + 1).toString(),
        text: (i + 1).toString(),
      }));
    },
  },
  methods: {
    cancelHandler() {
      this.filter.type = '';
      this.filter.time.yearStartAt = '';
      this.filter.time.monthStartAt = '';
      this.filter.time.yearEndAt = '';
      this.filter.time.monthEndAt = '';
      this.isModalShow = false;
    },
    exportHandler() {
      window.open(`${process.env.VUE_APP_API_URL}/export/award?${Str.query(this.filter)}&token=${this.token}`);
      this.filter.type = '';
      this.filter.time.yearStartAt = '';
      this.filter.time.monthStartAt = '';
      this.filter.time.yearEndAt = '';
      this.filter.time.monthEndAt = '';
      this.isModalShow = false;
    },
  },
};
</script>

<style lang="scss">
.award-export {
  &__modal-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(160, 160, 160, 0.7);
    z-index: 10;
  }
  &__modal {
    width: 720px;
    margin: 0 auto;
    margin-top: 168px;
    background-color: #fff;
    border-radius: 4px;
  }
}
</style>
